import * as actions from './actions';

export const updateFeedAfterReadArticle = (readedArticleId) => ({
    type: actions.UPDATE_LAWS_AFTER_READ_USERACTION,
    readedArticleId,
});

export const updateFeedAfterRateArticle = (articleId, userRating) => ({
    type: actions.UPDATE_LAWS_AFTER_RATE_USERACTION,
    articleId,
    userRating,
});

export const updateFeedAfterChangeImportanceArticle = (articleId, value) => ({
    type: actions.UPDATE_LAWS_AFTER_CHANGE_IMPORTANCE,
    articleId,
    value,
});

export const updateEcosystemStateInFeed = (articleId, ecosystemState) => ({
    type: actions.UPDATE_LAWS_AFTER_CHANGE_ECOSYSTEM_STATE,
    articleId,
    ecosystemState, // описание ниже
});

export const updateFeedAfterChangePlan = (articleId, value) => ({
    type: actions.UPDATE_LAWS_AFTER_CHANGE_PLAN_STATUS,
    articleId,
    value,
});

// ecosystemState: PropTypes.shape({
//     ecosystemStatus: PropTypes.shape({
//         action: PropTypes.string,
//         status: PropTypes.string,
//         deadline: PropTypes.string,
//     }),
//     ecosystemComments: PropTypes.shape({
//         comments_count: PropTypes.number,
//         messages: PropTypes.arrayOf(
//             PropTypes.shape({
//                 created: PropTypes.string,
//                 description: PropTypes.string,
//             })
//         ),
//     }),
//     ecosystemModifiedDate: PropTypes.string,
//     ecosystemFavourites: PropTypes.arrayOf(PropTypes.shape({
//         id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//         name: PropTypes.string,
//         title: PropTypes.string,
//     })),
//     ecosystemPendingFavourites: PropTypes.arrayOf(PropTypes.shape({
//         id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//         name: PropTypes.string,
//         title: PropTypes.string,
//         request_event_ids: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
//     })),
//     ecosystemRecommendedGroups: PropTypes.arrayOf(PropTypes.shape({
//         id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//         name: PropTypes.string,
//         title: PropTypes.string,
//     })),
// }),

export const cleanPersistedStorage = () => {
    console.log('+++CLEAN PERSISTED STORAGE 17+++');
    return async (dispatch) => {
        dispatch({ type: actions.CLEAN_PERSISTED_STORAGE });
        localStorage.clear();
    };
};

export const applyCovidFilters = (filters) => ({
    type: actions.APPLY_COVID_FILTERS,
    filters,
});

export const applySemanticFilters = (filters) => ({
    type: actions.APPLY_SEMANTIC_FILTERS,
    filters,
});



// WEBPACK FOOTER //
// ./src/redux_related/GENERAL/actionCreators.js